<div *ngIf="true" class="pt-sidebar">
  <div [ngClass]='opened ? "sidebar--open" : "sidebar--collapsed"' class="sidebar">
    <div class="sidebar-body">
      <div class='sidebar-container'>
        <div *ngFor='let item of items; trackBy: trackById'>
          <pt-sidebar-item
            (openMenu)='onOpenMenuItem($event)'
            *ngxPermissionsOnly='item.permissVisible'
            [autoCloseMenuItem]='true'
            [collapsed]='!opened'
            [itemMenuOpenedId]='itemMenuOpenedId'
            [item]='item'
          ></pt-sidebar-item>
        </div>

        <div>
          <pt-sidebar-item-storage
            *ngIf='storageInfo'
            [collapsed]='!opened'
            [item]='storage'
            [storageInfo]='storageInfo'
          ></pt-sidebar-item-storage>
        </div>
      </div>
    </div>

    <div class="sidebar-footer">
      <pt-sidebar-item-footer [collapsed]='!opened'
                              [version]="version"
                              class='footer'
      ></pt-sidebar-item-footer>

      <pt-sidebar-item-toogle (clickItem)='toggleOpened()'
                              [collapsed]='!opened'
                              [item]='toogle'
                              class='toggle'
      ></pt-sidebar-item-toogle>
    </div>
  </div>

  <div class="content">
    <ng-content select='[sidebarContent]'></ng-content>
  </div>
</div>
